/* eslint-disable prettier/prettier */
import { Box, makeStyles } from '@material-ui/core'
import React from 'react'
import Chatbox from './Chatbox'
import MyChats from './MyChats'

const useStyles = makeStyles({
  container: {
    width: '100vw',
    height: '100vh',

    background: '#d3d3d3',
    //  position:'relative'
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  component: {
    background: 'white',
    width: '70vw',
    height: '70vh',
    borderRadius: '2%',
    display: 'flex',
  },
  mychats: {
    width: '40%',
  },
  chatbox: {
    width: '60%',
  },
})

const Chat = () => {
  const classes = useStyles()
  return (
    <Box className={classes.container}>
      <Box className={classes.component}>
        <Box className={classes.mychats}>
          <MyChats />
        </Box>
        <Box className={classes.chatbox}>
          <Chatbox />
        </Box>
      </Box>
    </Box>
  )
}

export default Chat
